import { render, staticRenderFns } from "./vue-flow-edit-menu-group.vue?vue&type=template&id=30fd4c17"
import script from "./vue-flow-edit-menu-group.vue?vue&type=script&lang=js"
export * from "./vue-flow-edit-menu-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports